import { AskBotBar } from "../../AskBotBar";

export const HomeView = () => <AskBotBar />;
